import type {
  CreateEternalChallengeForUserResponse,
  CreateEternalChallengeProjectBody,
  CreateEternalChallengeProjectResponse,
  EditEternalChallengeProjectBody,
  EditEternalChallengeProjectResponse,
  RetrieveEternalChallengeStateResponse,
  SubmitProjectDetailsBody,
  SubmitProjectDetailsResponse,
  SubmitVideoUpdateBody,
  SubmitVideoUpdateResponse,
} from '$shared/api';
import { BaseService } from './utils/BaseService';

export class EternalService extends BaseService {
  retrieveEternalChallengeState(): Promise<RetrieveEternalChallengeStateResponse> {
    return this.client.send('/api/eternal/state', {
      method: 'GET',
    });
  }

  createEternalChallengeForUser(): Promise<CreateEternalChallengeForUserResponse> {
    return this.client.send('/api/eternal/challenge', {
      method: 'POST',
    });
  }

  submitProjectDetails(
    details: SubmitProjectDetailsBody,
  ): Promise<SubmitProjectDetailsResponse> {
    return this.client.send('/api/eternal/project-details', {
      method: 'POST',
      body: details,
    });
  }

  submitVideoUpdate(
    details: SubmitVideoUpdateBody,
  ): Promise<SubmitVideoUpdateResponse> {
    return this.client.send('/api/eternal/video-update', {
      method: 'POST',
      body: details,
    });
  }

  createProject(
    body: CreateEternalChallengeProjectBody,
  ): Promise<CreateEternalChallengeProjectResponse> {
    return this.client.send('/api/eternal/project', {
      method: 'POST',
      body,
    });
  }

  editProject(
    body: EditEternalChallengeProjectBody,
  ): Promise<EditEternalChallengeProjectResponse> {
    return this.client.send('/api/eternal/project', {
      method: 'PUT',
      body,
    });
  }
}
